import { TableCell, TableCellProps } from '@mui/material'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import classNames from 'classnames/bind'
import styles from './EFTable.module.scss'

const cx = classNames.bind(styles)

interface IEFTabelCellProps extends TableCellProps {
  isTableHead?: boolean
  isStickyColumn?: boolean
  headCellId?: any
}
export const EFTableCell = ({
  isStickyColumn,
  isTableHead,
  headCellId,
  ...props
}: IEFTabelCellProps) => {
  const theme = useAppSelector(currentTheme)
  return (
    <TableCell
      {...props}
      className={cx('table-cell', theme, props.className)}
    />
  )
}
